import { useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrentSettingsContext, HomeSettingsContext } from '../SettingsDataContext';
import { PapsContext } from '../PapsContext';
import { PageContext } from '../PageContext';
import { AppSettingsContext } from '../AppSettingsContext';
import { useAppUserAccess } from './useAppUserAccess';
import { currentHelpers } from 'global/redirection/current';
import { useHash, hashmark } from 'App';
import { clickToMethods } from 'global/cnr/reducers/ElementReducer';
import { allPageTypes } from 'global/enums/allPageTypes';

export const _allowNavSuffix = false

const _suffixExemptions = ['clients', 'events', 'landing', 'organizations', 'districts', 'sports']

const usePageNavigation = () => {

  const navigate = useNavigate();
  const appUserAccess = useAppUserAccess();

  const homeSettingsContext = useContext(HomeSettingsContext);
  const { paps_state } = useContext(PapsContext) ?? {};
  const { page_state } = useContext(PageContext) ?? {};
  const { currentSettings_state } = useContext(CurrentSettingsContext) ?? {};
  const appSettingsContext = useContext(AppSettingsContext)
  const { appSettings_state } = appSettingsContext ?? {}
  const { appHistory } = appSettings_state ?? {}

  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const navDeps = useMemo(() => ({
    homeSettingsContext,
    aps_page,
    aps_viewItems,
    appUserAccess,
    paps_state
  }), [homeSettingsContext, aps_page, aps_viewItems, appUserAccess, paps_state]);

  const handleNav = useCallback((navProps) => {
    console.clear()
    const { clickedItem, opts } = navProps
    console.log('⚡clickedItem⚡', clickedItem)
    let _opts = opts || {}
    if (_allowNavSuffix) {
      _opts.useSuffix = !_.includes(_suffixExemptions, clickedItem?.key)
    }

    navProps.opts = _opts
    push_simple(navProps);
  }, []);

  const handleNav_item = useCallback((clickedItem, itemKey, modifyMode, opts, ddn, ddProps, ddGroupIndex) => {
    // console.clear()
    console.log('⚡clickedItem⚡', clickedItem, itemKey)
    let _opts = opts || {}
    if (_allowNavSuffix) {
      _opts.useSuffix = !_.includes(_suffixExemptions, clickedItem?.key)
    }
    push_simple({
      clickedItem,
      itemKey,
      modifyMode,
      opts: _opts,
      ddn,
      ddProps,
      ddGroupIndex
    });
  },
    []
  );

  const handleNav_path = useCallback((path) => {
    navigate(path);
  }, [navigate]);

  const handleNav_notification = useCallback((newPayload) => {
    const { notification, data } = newPayload ?? {}
    const alert = notification ? notification : data
    const { clickPath } = data ?? {}
    const { clickSuffix, clients: clientKey, events: eventKey, page, pageKey } = alert ?? {}

    let url;
    if (clickPath) {
      if (useHash) { url = '/' + hashmark }
      url += '/' + clickPath
      navigate.push(clickPath)
    } else {
      if (useHash) { url = '/' + hashmark }
      if (clientKey) { url = '/clients/' + clientKey }
      if (eventKey) { url += '/events/' + eventKey }
      if (page) { url += '/' + page }
      if (pageKey) { url += '/' + pageKey }
      if (clickSuffix) { url += '/' + clickSuffix }
      navigate.push(url)
    }
  }, [navigate]);

  const handleNav_url = useCallback((e, url) => {
    if (url && !url.startsWith('https://')) {
      url = 'https://' + url;
    }

    e?.preventDefault();
    e?.stopPropagation();

    window.open(url, '_blank');
  }, []);

  const handleNav_back = useCallback((count = 1) => {
    navigate(-count);
  }, []);


  const push_simple = useCallback((navProps) => {
    const { clickedItem, opts, itemKey } = navProps ?? {}
    // appSettings_handlers.handleSet_startFetch()
    if (_allowNavSuffix && opts?.useSuffix) {
      if (itemKey) {
        navigate(`?pageItem=${clickedItem?.key}&pageItemKey=${itemKey}`)
      } else {
        navigate(`?pageItem=${clickedItem?.key} `)
      }
    } else {
      const np = truePushSimple(navDeps, navProps);

      if (np) {
        if (navProps?.modalMode) {
          navigate(np, { state: { modalMode: navProps.modalMode } });
        } else {
          navigate(np, { state: { modalMode: null } });
        }
      }
    }
  }, [navDeps, navigate]);

  return {
    handleNav,
    handleNav_item,
    handleNav_path,
    handleNav_url,
    handleNav_back,
    handleNav_notification,
  };
};

export default usePageNavigation;

const truePushSimple = (xxx, navProps, isAppDeveloper) => {
  const {
    homeSettingsContext,
    aps_page,
    aps_viewItems,
    appUserAccess,
    paps_state
  } = xxx ?? {}

  const {
    clickedItem,
    ddGroupIndex,
    ddn,
    ddProps,
    itemKey,
    modifyMode,
    opts,
  } = navProps
  // item edits and add handled from `dataReducer`     

  let { key: itemView, drillDown, itemKey: itemKey_clicked } = clickedItem ?? {}

  const clickTos = {
    app: false,
    detect: false,
    noClick: false,
    page: false,
    pdf: false,
    url: false,
  }

  if (clickTos.noClick && appUserAccess && (appUserAccess.accessLevel <= gEnums.accessLevels.admin)) { return false }

  const { homeSettings_state } = homeSettingsContext ?? {}
  const { homeSettings } = homeSettings_state ?? {}
  const { global: global_home } = homeSettings ?? {}
  const { appLanding, appShortUrls } = global_home ?? {}
  const { useAppLanding, appLandingUrls } = appLanding ?? {}
  const { useAppShortUrls, appLandingShortUrls } = appShortUrls ?? {}

  const { hash, pathname } = window.location
  const pathNameH = useHash ? hash.replace(hashmark + '/', '/') : pathname

  const { pathName, pathViews, landingView } = paps_state ?? {}

  const _isClient = pathViews?.clients
  const _isEvent = pathViews?.events

  let { clickTo } = opts ?? {}
  let { clickToMethod, page: click_toPage, ignoreClickMethod } = clickTo ?? {}

  if (clickTo) {
    switch (clickToMethod) {
      case clickToMethods.noClick:
        if (!ignoreClickMethod) {
          console.log('NO CLICK')
          return false
        }
      case clickToMethods.openAppUrl:
      case clickToMethods.openAppPdf:
        if (!ignoreClickMethod) {
          openAppUrl(clickTo.value)
          return false
        }
        break;
      case clickToMethods.page:
        itemView = click_toPage
        break;
      case clickToMethods.normal:
        break;
      default:
      // nothing
    }
  }

  const { itemData, directPath } = opts ?? {}
  if (itemData && itemData.as && itemData.as !== itemView) { itemView = itemData.as }

  const _itemKey = itemKey_clicked ? itemKey_clicked : itemKey

  let newPath = ddProps ? pathName : getNewPath(aps_viewItems, aps_page, paps_state, itemView, _itemKey, modifyMode, landingView, pathNameH)

  if (opts && opts.pageExt) { newPath += '/' + opts.pageExt }

  window.localStorage.removeItem('isBack')

  const _host = document.location.host

  switch (newPath) {
    case '/landing':
      newPath = '/'
      break;
    default:
    // nothing
  }

  // IMPORTANT: Push
  if (directPath) {
    currentHelpers.storageItem_set('lastPath', directPath);
    currentHelpers.storageItem_set('routeDepth', Object.keys(directPath).length);
    return directPath
    // navigate(directPath)
  } else {
    if (drillDown && drillDown.useDrillDown && opts) {
      let newDDGroupIndex = ddGroupIndex ? ddGroupIndex + 1 : 2
      return newPath + '/ddg/' + newDDGroupIndex
    } else if (ddn) {
      return currentHelpers.getSearchPath(newPath, ddProps, ddn)
    } else {
      if (pathNameH !== newPath) {
        if (useAppLanding && appLandingUrls && !isAppDeveloper && !_isClient && !_isEvent) {
          appLandingUrls.forEach(appLandingUrl => {
            const { host, hostUrl, baseUrl } = appLandingUrl
            if ((_host === host) && newPath.indexOf(baseUrl) < 0) {
              newPath = hostUrl
            }
          })
        }
        if (useAppShortUrls && appLandingShortUrls && !isAppDeveloper && !_isClient && !_isEvent) {
          const svs = currentHelpers.getQueryParamsObject()
          appLandingShortUrls.forEach(appLandingShortUrl => {
            const { shortUrl, redirectUrl } = appLandingShortUrl
            if ((svs === '/' + shortUrl)) {
              newPath = redirectUrl
            }
          })
        }
        currentHelpers.storageItem_set('lastPath', pathName);
        currentHelpers.storageItem_set('routeDepth', Object.keys(pathViews).length);
        return newPath
      }
    }
  }
}

const getNewPath = (aps_viewItems, aps_page, paps_state, itemView, itemKey, modifyMode, landingView, pathNameH) => {

  const { mainViews, lastRootPath, lastPathName } = paps_state ?? {}

  const pathViews = currentHelpers.getPathViews(pathNameH)

  let basePath = '';
  let newPath = '';

  switch (itemView) {

    case 'home':
      newPath = '/'
      break;

    case 'allClients':
      newPath = '/clients'
      break;

    case 'client':
      newPath = '/clients/' + pathViews['clients']
      break;

    default:

      if (modifyMode) {

        switch (lastPathName) {
          case landingView:
            newPath = lastRootPath
            break;
          default:
            newPath = pathNameH
        }

        switch (modifyMode) {
          case 'add':
            newPath += '/' + modifyMode
            break;
          case 'edit':
            newPath += '/' + modifyMode
            break;
          case 'viewSettings':
            newPath += '/' + modifyMode
            break;
          case 'qrCode':
            newPath += '/qrCode'
            break;
          case 'notifications':
            newPath += '/notifications'
            break;
          default:
          // nothing
        }

      } else {

        const x = getGviDeps(aps_viewItems, itemView, null, aps_page)
        const { dependencies, documentDependencies, dataParents } = x
        const pvKeys = Object.keys(pathViews)

        let _dataParents = dataParents

        switch (itemView) {
          case 'media':
            _dataParents = ['organizations', 'districts', 'sports']
            break;
          default:
          // nothing
        }

        if (dependencies && pathViews) {
          Object.keys(dependencies).forEach(key => {
            const dep = dependencies[key]
            if (pathViews[dep]) {
              basePath += '/' + dep + '/' + pathViews[dep]
            }
          })
        }

        if (documentDependencies) {
          documentDependencies.forEach(dd => {
            if (pvKeys.includes(dd)) {
              basePath += '/' + dd + '/' + pathViews[dd]
            }
          })
        }

        // IMPORTANT: add path for dataParents
        if (_dataParents && pathViews) {
          Object.keys(_dataParents).forEach(key => {
            const dep = _dataParents[key]
            if (pathViews[dep]) {
              basePath += '/' + dep + '/' + pathViews[dep]
            }
          })
        }

        newPath = basePath

        if (itemView) {
          newPath += '/' + itemView
          if (itemKey) {
            newPath += '/' + itemKey
            if (mainViews.includes(itemView)) {
              newPath += '/' + landingView
            }
          }
        }
      }
  }

  return newPath

}

const getGviDeps = (aps_viewItems, uivi, viewKey, aps_page) => {

  const viewItem_page = aps_page && aps_page.viewItems && aps_page.viewItems[uivi] ? aps_page && aps_page.viewItems && aps_page.viewItems[uivi] : null;
  const viewItem_app = aps_viewItems && aps_viewItems[uivi] && aps_viewItems[uivi] ? aps_viewItems[uivi] : null

  // dataSource 
  const { dataConstraints, dataSource } = viewItem_page ?? {}
  const _dataConstraints = dataConstraints ? dataConstraints : dataSource
  const { dataParents: dataParents_page, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName } = _dataConstraints ?? {}
  const { dependencies, documentDependencies, dataParents } = viewItem_app && viewItem_app.dataConnection ? viewItem_app.dataConnection : {}

  if (dependencies || dataParents || dataParents_page) {
    const dpp = dataParents_page ? dataParents_page : dataParents
    return { dependencies, documentDependencies, dataParents: dpp, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName }
  } else {
    let deps = null
    switch (uivi) {
      case allPageTypes.home:
        break;

      case allPageTypes.clients:
        if (viewKey) {
          deps = [allPageTypes.clients]
        }
        break;

      case allPageTypes.events:
        deps = [allPageTypes.clients]
        break;

      default:
        // deps = null
        deps = [allPageTypes.clients, allPageTypes.events]
        break;
    }

    return { dependencies: deps, documentDependencies, dataParents: null, useSeasonals, dataLinkType, useSubDataCollection, subDataCollectionName }
  }
}
